import React from 'react';

function MinusIcon({ color, ...restProps }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
            <path d="M14 1L0 0.999999" stroke={color || 'black'} strokeWidth="2" />
        </svg>
    );
}

export default MinusIcon;
